var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33335 3.33341C3.15654 3.33341 2.98697 3.40365 2.86195 3.52868C2.73693 3.6537 2.66669 3.82327 2.66669 4.00008V4.66675H13.3334V4.00008C13.3334 3.82327 13.2631 3.6537 13.1381 3.52868C13.0131 3.40365 12.8435 3.33341 12.6667 3.33341H3.33335ZM10.7667 13.3334H5.23002C5.07231 13.3334 4.91973 13.2774 4.79938 13.1755C4.67903 13.0736 4.59871 12.9323 4.57269 12.7767L3.33335 5.33341H12.6667L11.424 12.7774C11.398 12.9329 11.3176 13.0741 11.1973 13.1759C11.0769 13.2777 10.9243 13.3335 10.7667 13.3334ZM6.00002 3.00008C6.00001 2.91271 6.0343 2.82882 6.09552 2.76648C6.15674 2.70413 6.23999 2.66832 6.32735 2.66675H9.67269C9.76005 2.66832 9.8433 2.70413 9.90452 2.76648C9.96574 2.82882 10 2.91271 10 3.00008V3.33341H6.00002V3.00008Z",
    fill: "#DE350B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.6009fee4.svg";
export { ForwardRef as ReactComponent };